import { useTranslation } from "react-i18next";
import React from "react";

/** Spicy level indicator: 0 = pas épicé (grey), 1 = épicé (1 chili), 2 = très épicé (2 chilis). */
export const SpicyBadge = ({ level = 0, testId }) => {
  const { t } = useTranslation();
  const lvl = Number(level) || 0;
  const label = lvl === 2 ? t("spicyb.hot2") : lvl === 1 ? t("spicyb.hot1") : t("spicyb.hot0");
  return (
    <span
      data-testid={testId}
      title={label}
      aria-label={label}
      className={`inline-flex items-center text-sm leading-none select-none ${lvl === 0 ? "grayscale opacity-40" : ""}`}
    >
      🌶️{lvl === 2 && "🌶️"}
    </span>
  );
};
